import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';

import CardPartner from '@/components/CardPartner/CardPartner';
import { assureurs } from '@/constants/grilleAssureursData';
import useEqualizeCardHeights from '@/hooks/useEqualizeCardHeights';

import styles from './styles.module.css';

import type { PartnerTrackingContext } from '@/types/videoTutorials';

type PartnerGridItem = Pick<(typeof assureurs)[number], 'logo' | 'label' | 'assureur' | 'link' | 'modaleContrats'> & {
  id?: string;
};

interface PartnerGridProps {
  data?: PartnerGridItem[];
  trackingContext?: PartnerTrackingContext;
}

const itemKey = (item: PartnerGridItem) => item.id ?? item.assureur;

const PartnerGrid: React.FC<PartnerGridProps> = ({ data, trackingContext }) => {
  const items = data ?? assureurs;
  const containerRef = useEqualizeCardHeights(items.map(itemKey).join('|'));

  return (
    <div ref={containerRef}>
      <MtxGrid row className={styles.contentPartners}>
        {items.map((assureur) => (
          <MtxGrid col={4} colXl={4} colLg={4} colMd={6} colSm={6} colXs={12} key={itemKey(assureur)}>
            <CardPartner
              logo={assureur.logo}
              label={assureur.label}
              assureur={assureur.assureur}
              link={assureur.link}
              modaleContrats={assureur.modaleContrats}
              trackingContext={trackingContext}
            />
          </MtxGrid>
        ))}
      </MtxGrid>
    </div>
  );
};

export default PartnerGrid;
